import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const MISModule = {
  state: {
    MISREQUEST: [],
    MISLOADING: false,
    MISERROR: null,
    MISDEPARTMENTS: [],
    MISTotalPages: 1,
  },
  getters: {
    GETMISREQUEST: (state) => state.MISREQUEST,
    GETMISLOADING: (state) => state.MISLOADING,
    GETMISERROR: (state) => state.MISERROR,
    GETMISDEPARTMENTS: (state) => state.MISDEPARTMENTS,
    GETMISTotalPages: (state) => state.MISTotalPages,
  },
  actions: {
    [ACTIONS.MIS_GET_ALL]: (context, query) => {
      context.commit(ACTIONS.MIS_GET_ALL_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/GetAllMISRepost" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.MIS_GET_ALL_SUCCESS,
              ACTIONS.MIS_GET_ALL_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.MIS_GET_ALL_ERROR);
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.MIS_GET_ALL_PENDING]: (state) => {
      state.MISLOADING = true;
      state.MISERROR = null;
    },
    [ACTIONS.MIS_GET_ALL_SUCCESS]: (state, data) => {
      state.MISLOADING = false;
      state.MISERROR = null;
      state.MISREQUEST = data.MISReport;
      state.MISDEPARTMENTS = data.Departments;
      state.MISTotalPages = data.totalRecords;
    },
    [ACTIONS.MIS_GET_ALL_ERROR]: (state, msg) => {
      state.MISLOADING = false;
      state.MISERROR = msg;
    },
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      } else {
        commit(SuccessAction);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 2 ||
        data.StatusCode == 429 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};

export default MISModule;
